import { ArtefactTitle } from '@modules/common/components/ArtefactTitle';
import { useIsSearchToFeedEnabled } from '@modules/common/hooks';
import { ArtefactType } from '@modules/common/types';
import { useRenameSearch } from '@modules/feed/components/SearchAnalysisToolbar/hooks/useRenameSearch';
import { isSavedSearchAuthor } from '@modules/feed/components/SearchAnalysisToolbar/utils';
import { useSearchStore } from '@modules/feed/store/searchStore';
import { Divider, Stack } from '@mui/material';
import { shallow } from 'zustand/shallow';

export const SearchTitle = () => {
  const isSearchToFeedEnabled = useIsSearchToFeedEnabled();

  const name = useSearchStore(({ data: { title } = {} }) => title);
  const handleRenameSearch = useRenameSearch();
  const { id, isEditable } = useSearchStore(
    ({ data }) => ({
      id: data?.id,
      isEditable: Boolean(data?.editToken),
    }),
    shallow,
  );
  const canRenameArtefact = isSavedSearchAuthor({
    analysisID: id,
    isEditable,
  });
  const createdBy = useSearchStore(({ data: { createdBy } = {} }) => createdBy);
  const updatedAt = useSearchStore(({ data: { updatedAt } = {} }) => updatedAt);

  const creatorName = createdBy
    ? `${createdBy?.firstName} ${createdBy?.lastName}`
    : '';

  return (
    <Stack direction="row" spacing={1}>
      <ArtefactTitle
        name={name || `New ${isSearchToFeedEnabled ? 'Feed' : 'Search'}`}
        artefactType={ArtefactType.Search}
        onArtefactRename={canRenameArtefact ? handleRenameSearch : undefined}
        createdBy={creatorName}
        updatedAt={updatedAt?.fromNow()}
      />
      <Divider
        orientation="vertical"
        sx={{
          height: creatorName ? '42px !important' : '20px !important',
        }}
        flexItem
      />
    </Stack>
  );
};
